import type { LiveTranscriptTraceSink } from './meetings-live-transcript.utils';
import type {
  UtteranceProjectionTraceEvent,
  UtteranceProjectionTraceSink,
} from './meetings-utterance-projection';
import type {
  TranscriptSyncTraceEvent,
  TranscriptSyncTraceSink,
} from './transcript-sync';

const LOCAL_TRANSCRIPTION_DEBUG_STORAGE_KEY = 'localTranscriptionDebug';

type LocalTranscriptionDebugTraceEvent =
  | Parameters<LiveTranscriptTraceSink>[0]
  | TranscriptSyncTraceEvent
  | UtteranceProjectionTraceEvent;

function isLocalTranscriptionDebugEnabled(): boolean {
  if (typeof window === 'undefined') return false;

  try {
    return (
      window.localStorage.getItem(LOCAL_TRANSCRIPTION_DEBUG_STORAGE_KEY) ===
      'true'
    );
  } catch {
    return false;
  }
}

export function getLocalTranscriptionDebugTraceOptions(source: string): {
  trace?: LiveTranscriptTraceSink;
  traceSource?: string;
} {
  if (!isLocalTranscriptionDebugEnabled()) return {};

  return {
    trace: logLocalTranscriptionDebugTrace,
    traceSource: source,
  };
}

export function getLocalTranscriptionUtteranceTraceOptions(source: string): {
  trace?: UtteranceProjectionTraceSink;
  traceSource?: string;
} {
  if (!isLocalTranscriptionDebugEnabled()) return {};

  return {
    trace: logLocalTranscriptionDebugTrace,
    traceSource: source,
  };
}

export function getLocalTranscriptionSyncTraceSink():
  | TranscriptSyncTraceSink
  | undefined {
  if (!isLocalTranscriptionDebugEnabled()) return undefined;
  return logLocalTranscriptionDebugTrace;
}

function logLocalTranscriptionDebugTrace(
  event: LocalTranscriptionDebugTraceEvent
): void {
  console.info('[local-transcription-debug]', event);
}
